"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuditClient = useAuditClient;
const AuditClient_1 = require("@juvare/platform-sdk-js/AuditClient");
const react_1 = __importDefault(require("react"));
function useAuditClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new AuditClient_1.AuditClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
